module.exports = __webpack_public_path__ + "static/step-logo-adcc6a3f8d5161e606fec386e349975c.png";